var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', {
    staticClass: "text-right"
  }, [_c('b-badge', {
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.roleName) + " ")])], 1), _c('b-card-actions', {
    attrs: {
      "title": "Dashboard & Roles",
      "action-collapse": ""
    }
  }, [_c('vue-good-table', {
    attrs: {
      "max-height": "600px",
      "styleClass": "vgt-table striped",
      "fixed-header": true,
      "columns": _vm.columns,
      "rows": _vm.dashboard,
      "sort-options": {
        enabled: false
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$row, _props$row$permission, _props$row3, _props$row4, _props$row4$permissio, _props$row5, _props$row6, _props$row6$permissio, _props$row7, _props$row8, _props$row8$permissio, _props$row9, _props$row10, _props$row10$permissi, _props$row11, _props$row12, _props$row12$permissi, _props$row13, _props$row14, _props$row14$permissi;
        return [props.column.field === 'name' ? _c('div', [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(_vm._s(props.row.name))])]) : props.column.field === 'all' ? _c('div', [_c('b-form-checkbox', {
          attrs: {
            "checked": _vm.roleHasPermissionsIncludes(_vm.mapPermissionsIds((_props$row = props.row) === null || _props$row === void 0 ? void 0 : (_props$row$permission = _props$row.permissions) === null || _props$row$permission === void 0 ? void 0 : _props$row$permission.data)),
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          on: {
            "change": function change(isChecked) {
              var _props$row2, _props$row2$permissio;
              return _vm.onChangeSwitch(isChecked, _vm.mapPermissionsIds((_props$row2 = props.row) === null || _props$row2 === void 0 ? void 0 : (_props$row2$permissio = _props$row2.permissions) === null || _props$row2$permissio === void 0 ? void 0 : _props$row2$permissio.data), true);
            }
          }
        })], 1) : props.column.field === 'access' ? _c('div', [(_props$row3 = props.row) !== null && _props$row3 !== void 0 && _props$row3.permissions ? [_vm._l((_props$row4 = props.row) === null || _props$row4 === void 0 ? void 0 : (_props$row4$permissio = _props$row4.permissions) === null || _props$row4$permissio === void 0 ? void 0 : _props$row4$permissio.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'access' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'create' ? _c('div', [(_props$row5 = props.row) !== null && _props$row5 !== void 0 && _props$row5.permissions ? [_vm._l((_props$row6 = props.row) === null || _props$row6 === void 0 ? void 0 : (_props$row6$permissio = _props$row6.permissions) === null || _props$row6$permissio === void 0 ? void 0 : _props$row6$permissio.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'create' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'show' ? _c('div', [(_props$row7 = props.row) !== null && _props$row7 !== void 0 && _props$row7.permissions ? [_vm._l((_props$row8 = props.row) === null || _props$row8 === void 0 ? void 0 : (_props$row8$permissio = _props$row8.permissions) === null || _props$row8$permissio === void 0 ? void 0 : _props$row8$permissio.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'show' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'edit' ? _c('div', [(_props$row9 = props.row) !== null && _props$row9 !== void 0 && _props$row9.permissions ? [_vm._l((_props$row10 = props.row) === null || _props$row10 === void 0 ? void 0 : (_props$row10$permissi = _props$row10.permissions) === null || _props$row10$permissi === void 0 ? void 0 : _props$row10$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'edit' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'delete' ? _c('div', [(_props$row11 = props.row) !== null && _props$row11 !== void 0 && _props$row11.permissions ? [_vm._l((_props$row12 = props.row) === null || _props$row12 === void 0 ? void 0 : (_props$row12$permissi = _props$row12.permissions) === null || _props$row12$permissi === void 0 ? void 0 : _props$row12$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'delete' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'others' ? _c('div', [(_props$row13 = props.row) !== null && _props$row13 !== void 0 && _props$row13.permissions ? _vm._l((_props$row14 = props.row) === null || _props$row14 === void 0 ? void 0 : (_props$row14$permissi = _props$row14.permissions) === null || _props$row14$permissi === void 0 ? void 0 : _props$row14$permissi.data, function (item, index) {
          var _props$row15, _props$row15$permissi, _props$row16, _props$row16$permissi;
          return _c('div', {
            key: index
          }, [index % 2 === 0 ? _c('b-row', [_c('b-col', {
            attrs: {
              "cols": "6"
            }
          }, [item.group === 'others' ? [_c('b-form-checkbox', {
            key: item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("strSnakeToPascal")(item.name)) + " ")])] : _vm._e()], 2), (_props$row15 = props.row) !== null && _props$row15 !== void 0 && (_props$row15$permissi = _props$row15.permissions) !== null && _props$row15$permissi !== void 0 && _props$row15$permissi.data[index + 1] ? _c('b-col', {
            attrs: {
              "cols": "6"
            }
          }, [((_props$row16 = props.row) === null || _props$row16 === void 0 ? void 0 : (_props$row16$permissi = _props$row16.permissions) === null || _props$row16$permissi === void 0 ? void 0 : _props$row16$permissi.data[index + 1].group) === 'others' ? [_c('b-form-checkbox', {
            key: props.row.permissions.data[index + 1].id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(props.row.permissions.data[index + 1].id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, props.row.permissions.data[index + 1].id);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("strSnakeToPascal")(props.row.permissions.data[index + 1].name)) + " ")])] : _vm._e()], 2) : _vm._e()], 1) : _vm._e()], 1);
        }) : _vm._e()], 2) : _vm._e()];
      }
    }])
  })], 1), _c('b-card-actions', {
    attrs: {
      "title": "Users",
      "action-collapse": ""
    }
  }, [_c('vue-good-table', {
    attrs: {
      "max-height": "600px",
      "styleClass": "vgt-table striped",
      "fixed-header": true,
      "columns": _vm.columns,
      "rows": _vm.user,
      "sort-options": {
        enabled: false
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$row17, _props$row17$permissi, _props$row19, _props$row20, _props$row20$permissi, _props$row21, _props$row22, _props$row22$permissi, _props$row23, _props$row24, _props$row24$permissi, _props$row25, _props$row26, _props$row26$permissi, _props$row27, _props$row28, _props$row28$permissi, _props$row29, _props$row30, _props$row30$permissi;
        return [props.column.field === 'name' ? _c('div', [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(_vm._s(props.row.name))])]) : props.column.field === 'all' ? _c('div', [_c('b-form-checkbox', {
          attrs: {
            "checked": _vm.roleHasPermissionsIncludes(_vm.mapPermissionsIds((_props$row17 = props.row) === null || _props$row17 === void 0 ? void 0 : (_props$row17$permissi = _props$row17.permissions) === null || _props$row17$permissi === void 0 ? void 0 : _props$row17$permissi.data)),
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          on: {
            "change": function change(isChecked) {
              var _props$row18, _props$row18$permissi;
              return _vm.onChangeSwitch(isChecked, _vm.mapPermissionsIds((_props$row18 = props.row) === null || _props$row18 === void 0 ? void 0 : (_props$row18$permissi = _props$row18.permissions) === null || _props$row18$permissi === void 0 ? void 0 : _props$row18$permissi.data), true);
            }
          }
        })], 1) : props.column.field === 'access' ? _c('div', [(_props$row19 = props.row) !== null && _props$row19 !== void 0 && _props$row19.permissions ? [_vm._l((_props$row20 = props.row) === null || _props$row20 === void 0 ? void 0 : (_props$row20$permissi = _props$row20.permissions) === null || _props$row20$permissi === void 0 ? void 0 : _props$row20$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'access' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'create' ? _c('div', [(_props$row21 = props.row) !== null && _props$row21 !== void 0 && _props$row21.permissions ? [_vm._l((_props$row22 = props.row) === null || _props$row22 === void 0 ? void 0 : (_props$row22$permissi = _props$row22.permissions) === null || _props$row22$permissi === void 0 ? void 0 : _props$row22$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'create' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'show' ? _c('div', [(_props$row23 = props.row) !== null && _props$row23 !== void 0 && _props$row23.permissions ? [_vm._l((_props$row24 = props.row) === null || _props$row24 === void 0 ? void 0 : (_props$row24$permissi = _props$row24.permissions) === null || _props$row24$permissi === void 0 ? void 0 : _props$row24$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'show' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'edit' ? _c('div', [(_props$row25 = props.row) !== null && _props$row25 !== void 0 && _props$row25.permissions ? [_vm._l((_props$row26 = props.row) === null || _props$row26 === void 0 ? void 0 : (_props$row26$permissi = _props$row26.permissions) === null || _props$row26$permissi === void 0 ? void 0 : _props$row26$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'edit' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'delete' ? _c('div', [(_props$row27 = props.row) !== null && _props$row27 !== void 0 && _props$row27.permissions ? [_vm._l((_props$row28 = props.row) === null || _props$row28 === void 0 ? void 0 : (_props$row28$permissi = _props$row28.permissions) === null || _props$row28$permissi === void 0 ? void 0 : _props$row28$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'delete' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'others' ? _c('div', [(_props$row29 = props.row) !== null && _props$row29 !== void 0 && _props$row29.permissions ? _vm._l((_props$row30 = props.row) === null || _props$row30 === void 0 ? void 0 : (_props$row30$permissi = _props$row30.permissions) === null || _props$row30$permissi === void 0 ? void 0 : _props$row30$permissi.data, function (item, index) {
          var _props$row31, _props$row31$permissi, _props$row32, _props$row32$permissi;
          return _c('div', {
            key: index
          }, [index % 2 === 0 ? _c('b-row', [_c('b-col', {
            attrs: {
              "cols": "6"
            }
          }, [item.group === 'others' ? [_c('b-form-checkbox', {
            key: item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("strSnakeToPascal")(item.name)) + " ")])] : _vm._e()], 2), (_props$row31 = props.row) !== null && _props$row31 !== void 0 && (_props$row31$permissi = _props$row31.permissions) !== null && _props$row31$permissi !== void 0 && _props$row31$permissi.data[index + 1] ? _c('b-col', {
            attrs: {
              "cols": "6"
            }
          }, [((_props$row32 = props.row) === null || _props$row32 === void 0 ? void 0 : (_props$row32$permissi = _props$row32.permissions) === null || _props$row32$permissi === void 0 ? void 0 : _props$row32$permissi.data[index + 1].group) === 'others' ? [_c('b-form-checkbox', {
            key: props.row.permissions.data[index + 1].id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(props.row.permissions.data[index + 1].id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, props.row.permissions.data[index + 1].id);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("strSnakeToPascal")(props.row.permissions.data[index + 1].name)) + " ")])] : _vm._e()], 2) : _vm._e()], 1) : _vm._e()], 1);
        }) : _vm._e()], 2) : _vm._e()];
      }
    }])
  })], 1), _c('b-card-actions', {
    attrs: {
      "title": "Coupon",
      "action-collapse": ""
    }
  }, [_c('vue-good-table', {
    attrs: {
      "max-height": "600px",
      "styleClass": "vgt-table striped",
      "fixed-header": true,
      "columns": _vm.columns,
      "rows": _vm.coupon,
      "sort-options": {
        enabled: false
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$row33, _props$row33$permissi, _props$row35, _props$row36, _props$row36$permissi, _props$row37, _props$row38, _props$row38$permissi, _props$row39, _props$row40, _props$row40$permissi, _props$row41, _props$row42, _props$row42$permissi, _props$row43, _props$row44, _props$row44$permissi, _props$row45, _props$row46, _props$row46$permissi;
        return [props.column.field === 'name' ? _c('div', [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(_vm._s(props.row.name))])]) : props.column.field === 'all' ? _c('div', [_c('b-form-checkbox', {
          attrs: {
            "checked": _vm.roleHasPermissionsIncludes(_vm.mapPermissionsIds((_props$row33 = props.row) === null || _props$row33 === void 0 ? void 0 : (_props$row33$permissi = _props$row33.permissions) === null || _props$row33$permissi === void 0 ? void 0 : _props$row33$permissi.data)),
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          on: {
            "change": function change(isChecked) {
              var _props$row34, _props$row34$permissi;
              return _vm.onChangeSwitch(isChecked, _vm.mapPermissionsIds((_props$row34 = props.row) === null || _props$row34 === void 0 ? void 0 : (_props$row34$permissi = _props$row34.permissions) === null || _props$row34$permissi === void 0 ? void 0 : _props$row34$permissi.data), true);
            }
          }
        })], 1) : props.column.field === 'access' ? _c('div', [(_props$row35 = props.row) !== null && _props$row35 !== void 0 && _props$row35.permissions ? [_vm._l((_props$row36 = props.row) === null || _props$row36 === void 0 ? void 0 : (_props$row36$permissi = _props$row36.permissions) === null || _props$row36$permissi === void 0 ? void 0 : _props$row36$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'access' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'create' ? _c('div', [(_props$row37 = props.row) !== null && _props$row37 !== void 0 && _props$row37.permissions ? [_vm._l((_props$row38 = props.row) === null || _props$row38 === void 0 ? void 0 : (_props$row38$permissi = _props$row38.permissions) === null || _props$row38$permissi === void 0 ? void 0 : _props$row38$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'create' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'show' ? _c('div', [(_props$row39 = props.row) !== null && _props$row39 !== void 0 && _props$row39.permissions ? [_vm._l((_props$row40 = props.row) === null || _props$row40 === void 0 ? void 0 : (_props$row40$permissi = _props$row40.permissions) === null || _props$row40$permissi === void 0 ? void 0 : _props$row40$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'show' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'edit' ? _c('div', [(_props$row41 = props.row) !== null && _props$row41 !== void 0 && _props$row41.permissions ? [_vm._l((_props$row42 = props.row) === null || _props$row42 === void 0 ? void 0 : (_props$row42$permissi = _props$row42.permissions) === null || _props$row42$permissi === void 0 ? void 0 : _props$row42$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'edit' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'delete' ? _c('div', [(_props$row43 = props.row) !== null && _props$row43 !== void 0 && _props$row43.permissions ? [_vm._l((_props$row44 = props.row) === null || _props$row44 === void 0 ? void 0 : (_props$row44$permissi = _props$row44.permissions) === null || _props$row44$permissi === void 0 ? void 0 : _props$row44$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'delete' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'others' ? _c('div', [(_props$row45 = props.row) !== null && _props$row45 !== void 0 && _props$row45.permissions ? _vm._l((_props$row46 = props.row) === null || _props$row46 === void 0 ? void 0 : (_props$row46$permissi = _props$row46.permissions) === null || _props$row46$permissi === void 0 ? void 0 : _props$row46$permissi.data, function (item, index) {
          var _props$row47, _props$row47$permissi, _props$row48, _props$row48$permissi;
          return _c('div', {
            key: index
          }, [index % 2 === 0 ? _c('b-row', [_c('b-col', {
            attrs: {
              "cols": "6"
            }
          }, [item.group === 'others' ? [_c('b-form-checkbox', {
            key: item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("strSnakeToPascal")(item.name)) + " ")])] : _vm._e()], 2), (_props$row47 = props.row) !== null && _props$row47 !== void 0 && (_props$row47$permissi = _props$row47.permissions) !== null && _props$row47$permissi !== void 0 && _props$row47$permissi.data[index + 1] ? _c('b-col', {
            attrs: {
              "cols": "6"
            }
          }, [((_props$row48 = props.row) === null || _props$row48 === void 0 ? void 0 : (_props$row48$permissi = _props$row48.permissions) === null || _props$row48$permissi === void 0 ? void 0 : _props$row48$permissi.data[index + 1].group) === 'others' ? [_c('b-form-checkbox', {
            key: props.row.permissions.data[index + 1].id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(props.row.permissions.data[index + 1].id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, props.row.permissions.data[index + 1].id);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("strSnakeToPascal")(props.row.permissions.data[index + 1].name)) + " ")])] : _vm._e()], 2) : _vm._e()], 1) : _vm._e()], 1);
        }) : _vm._e()], 2) : _vm._e()];
      }
    }])
  })], 1), _c('b-card-actions', {
    attrs: {
      "title": "Company",
      "action-collapse": ""
    }
  }, [_c('vue-good-table', {
    attrs: {
      "max-height": "600px",
      "styleClass": "vgt-table striped",
      "fixed-header": true,
      "columns": _vm.columns,
      "rows": _vm.company,
      "sort-options": {
        enabled: false
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$row49, _props$row49$permissi, _props$row51, _props$row52, _props$row52$permissi, _props$row53, _props$row54, _props$row54$permissi, _props$row55, _props$row56, _props$row56$permissi, _props$row57, _props$row58, _props$row58$permissi, _props$row59, _props$row60, _props$row60$permissi, _props$row61, _props$row62, _props$row62$permissi;
        return [props.column.field === 'name' ? _c('div', [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(_vm._s(props.row.name))])]) : props.column.field === 'all' ? _c('div', [_c('b-form-checkbox', {
          attrs: {
            "checked": _vm.roleHasPermissionsIncludes(_vm.mapPermissionsIds((_props$row49 = props.row) === null || _props$row49 === void 0 ? void 0 : (_props$row49$permissi = _props$row49.permissions) === null || _props$row49$permissi === void 0 ? void 0 : _props$row49$permissi.data)),
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          on: {
            "change": function change(isChecked) {
              var _props$row50, _props$row50$permissi;
              return _vm.onChangeSwitch(isChecked, _vm.mapPermissionsIds((_props$row50 = props.row) === null || _props$row50 === void 0 ? void 0 : (_props$row50$permissi = _props$row50.permissions) === null || _props$row50$permissi === void 0 ? void 0 : _props$row50$permissi.data), true);
            }
          }
        })], 1) : props.column.field === 'access' ? _c('div', [(_props$row51 = props.row) !== null && _props$row51 !== void 0 && _props$row51.permissions ? [_vm._l((_props$row52 = props.row) === null || _props$row52 === void 0 ? void 0 : (_props$row52$permissi = _props$row52.permissions) === null || _props$row52$permissi === void 0 ? void 0 : _props$row52$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'access' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'create' ? _c('div', [(_props$row53 = props.row) !== null && _props$row53 !== void 0 && _props$row53.permissions ? [_vm._l((_props$row54 = props.row) === null || _props$row54 === void 0 ? void 0 : (_props$row54$permissi = _props$row54.permissions) === null || _props$row54$permissi === void 0 ? void 0 : _props$row54$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'create' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'show' ? _c('div', [(_props$row55 = props.row) !== null && _props$row55 !== void 0 && _props$row55.permissions ? [_vm._l((_props$row56 = props.row) === null || _props$row56 === void 0 ? void 0 : (_props$row56$permissi = _props$row56.permissions) === null || _props$row56$permissi === void 0 ? void 0 : _props$row56$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'show' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'edit' ? _c('div', [(_props$row57 = props.row) !== null && _props$row57 !== void 0 && _props$row57.permissions ? [_vm._l((_props$row58 = props.row) === null || _props$row58 === void 0 ? void 0 : (_props$row58$permissi = _props$row58.permissions) === null || _props$row58$permissi === void 0 ? void 0 : _props$row58$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'edit' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'delete' ? _c('div', [(_props$row59 = props.row) !== null && _props$row59 !== void 0 && _props$row59.permissions ? [_vm._l((_props$row60 = props.row) === null || _props$row60 === void 0 ? void 0 : (_props$row60$permissi = _props$row60.permissions) === null || _props$row60$permissi === void 0 ? void 0 : _props$row60$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'delete' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'others' ? _c('div', [(_props$row61 = props.row) !== null && _props$row61 !== void 0 && _props$row61.permissions ? _vm._l((_props$row62 = props.row) === null || _props$row62 === void 0 ? void 0 : (_props$row62$permissi = _props$row62.permissions) === null || _props$row62$permissi === void 0 ? void 0 : _props$row62$permissi.data, function (item, index) {
          var _props$row63, _props$row63$permissi, _props$row64, _props$row64$permissi;
          return _c('div', {
            key: index
          }, [index % 2 === 0 ? _c('b-row', [_c('b-col', {
            attrs: {
              "cols": "6"
            }
          }, [item.group === 'others' ? [_c('b-form-checkbox', {
            key: item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("strSnakeToPascal")(item.name)) + " ")])] : _vm._e()], 2), (_props$row63 = props.row) !== null && _props$row63 !== void 0 && (_props$row63$permissi = _props$row63.permissions) !== null && _props$row63$permissi !== void 0 && _props$row63$permissi.data[index + 1] ? _c('b-col', {
            attrs: {
              "cols": "6"
            }
          }, [((_props$row64 = props.row) === null || _props$row64 === void 0 ? void 0 : (_props$row64$permissi = _props$row64.permissions) === null || _props$row64$permissi === void 0 ? void 0 : _props$row64$permissi.data[index + 1].group) === 'others' ? [_c('b-form-checkbox', {
            key: props.row.permissions.data[index + 1].id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(props.row.permissions.data[index + 1].id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, props.row.permissions.data[index + 1].id);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("strSnakeToPascal")(props.row.permissions.data[index + 1].name)) + " ")])] : _vm._e()], 2) : _vm._e()], 1) : _vm._e()], 1);
        }) : _vm._e()], 2) : _vm._e()];
      }
    }])
  })], 1), _c('b-card-actions', {
    attrs: {
      "title": "Mail Template",
      "action-collapse": ""
    }
  }, [_c('vue-good-table', {
    attrs: {
      "max-height": "600px",
      "styleClass": "vgt-table striped",
      "fixed-header": true,
      "columns": _vm.columns,
      "rows": _vm.mailTemplate,
      "sort-options": {
        enabled: false
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$row65, _props$row65$permissi, _props$row67, _props$row68, _props$row68$permissi, _props$row69, _props$row70, _props$row70$permissi, _props$row71, _props$row72, _props$row72$permissi, _props$row73, _props$row74, _props$row74$permissi, _props$row75, _props$row76, _props$row76$permissi, _props$row77, _props$row78, _props$row78$permissi;
        return [props.column.field === 'name' ? _c('div', [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(_vm._s(props.row.name))])]) : props.column.field === 'all' ? _c('div', [_c('b-form-checkbox', {
          attrs: {
            "checked": _vm.roleHasPermissionsIncludes(_vm.mapPermissionsIds((_props$row65 = props.row) === null || _props$row65 === void 0 ? void 0 : (_props$row65$permissi = _props$row65.permissions) === null || _props$row65$permissi === void 0 ? void 0 : _props$row65$permissi.data)),
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          on: {
            "change": function change(isChecked) {
              var _props$row66, _props$row66$permissi;
              return _vm.onChangeSwitch(isChecked, _vm.mapPermissionsIds((_props$row66 = props.row) === null || _props$row66 === void 0 ? void 0 : (_props$row66$permissi = _props$row66.permissions) === null || _props$row66$permissi === void 0 ? void 0 : _props$row66$permissi.data), true);
            }
          }
        })], 1) : props.column.field === 'access' ? _c('div', [(_props$row67 = props.row) !== null && _props$row67 !== void 0 && _props$row67.permissions ? [_vm._l((_props$row68 = props.row) === null || _props$row68 === void 0 ? void 0 : (_props$row68$permissi = _props$row68.permissions) === null || _props$row68$permissi === void 0 ? void 0 : _props$row68$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'access' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'create' ? _c('div', [(_props$row69 = props.row) !== null && _props$row69 !== void 0 && _props$row69.permissions ? [_vm._l((_props$row70 = props.row) === null || _props$row70 === void 0 ? void 0 : (_props$row70$permissi = _props$row70.permissions) === null || _props$row70$permissi === void 0 ? void 0 : _props$row70$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'create' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'show' ? _c('div', [(_props$row71 = props.row) !== null && _props$row71 !== void 0 && _props$row71.permissions ? [_vm._l((_props$row72 = props.row) === null || _props$row72 === void 0 ? void 0 : (_props$row72$permissi = _props$row72.permissions) === null || _props$row72$permissi === void 0 ? void 0 : _props$row72$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'show' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'edit' ? _c('div', [(_props$row73 = props.row) !== null && _props$row73 !== void 0 && _props$row73.permissions ? [_vm._l((_props$row74 = props.row) === null || _props$row74 === void 0 ? void 0 : (_props$row74$permissi = _props$row74.permissions) === null || _props$row74$permissi === void 0 ? void 0 : _props$row74$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'edit' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'delete' ? _c('div', [(_props$row75 = props.row) !== null && _props$row75 !== void 0 && _props$row75.permissions ? [_vm._l((_props$row76 = props.row) === null || _props$row76 === void 0 ? void 0 : (_props$row76$permissi = _props$row76.permissions) === null || _props$row76$permissi === void 0 ? void 0 : _props$row76$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'delete' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'others' ? _c('div', [(_props$row77 = props.row) !== null && _props$row77 !== void 0 && _props$row77.permissions ? _vm._l((_props$row78 = props.row) === null || _props$row78 === void 0 ? void 0 : (_props$row78$permissi = _props$row78.permissions) === null || _props$row78$permissi === void 0 ? void 0 : _props$row78$permissi.data, function (item, index) {
          var _props$row79, _props$row79$permissi, _props$row80, _props$row80$permissi;
          return _c('div', {
            key: index
          }, [index % 2 === 0 ? _c('b-row', [_c('b-col', {
            attrs: {
              "cols": "6"
            }
          }, [item.group === 'others' ? [_c('b-form-checkbox', {
            key: item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("strSnakeToPascal")(item.name)) + " ")])] : _vm._e()], 2), (_props$row79 = props.row) !== null && _props$row79 !== void 0 && (_props$row79$permissi = _props$row79.permissions) !== null && _props$row79$permissi !== void 0 && _props$row79$permissi.data[index + 1] ? _c('b-col', {
            attrs: {
              "cols": "6"
            }
          }, [((_props$row80 = props.row) === null || _props$row80 === void 0 ? void 0 : (_props$row80$permissi = _props$row80.permissions) === null || _props$row80$permissi === void 0 ? void 0 : _props$row80$permissi.data[index + 1].group) === 'others' ? [_c('b-form-checkbox', {
            key: props.row.permissions.data[index + 1].id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(props.row.permissions.data[index + 1].id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, props.row.permissions.data[index + 1].id);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("strSnakeToPascal")(props.row.permissions.data[index + 1].name)) + " ")])] : _vm._e()], 2) : _vm._e()], 1) : _vm._e()], 1);
        }) : _vm._e()], 2) : _vm._e()];
      }
    }])
  })], 1), _c('b-card-actions', {
    attrs: {
      "title": "Company Request",
      "action-collapse": ""
    }
  }, [_c('vue-good-table', {
    attrs: {
      "max-height": "600px",
      "styleClass": "vgt-table striped",
      "fixed-header": true,
      "columns": _vm.columns,
      "rows": _vm.companyRequest,
      "sort-options": {
        enabled: false
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(props) {
        var _props$row81, _props$row81$permissi, _props$row83, _props$row84, _props$row84$permissi, _props$row85, _props$row86, _props$row86$permissi, _props$row87, _props$row88, _props$row88$permissi, _props$row89, _props$row90, _props$row90$permissi, _props$row91, _props$row92, _props$row92$permissi, _props$row93, _props$row94, _props$row94$permissi;
        return [props.column.field === 'name' ? _c('div', [_c('span', {
          staticClass: "text-nowrap"
        }, [_vm._v(_vm._s(props.row.name))])]) : props.column.field === 'all' ? _c('div', [_c('b-form-checkbox', {
          attrs: {
            "checked": _vm.roleHasPermissionsIncludes(_vm.mapPermissionsIds((_props$row81 = props.row) === null || _props$row81 === void 0 ? void 0 : (_props$row81$permissi = _props$row81.permissions) === null || _props$row81$permissi === void 0 ? void 0 : _props$row81$permissi.data)),
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          on: {
            "change": function change(isChecked) {
              var _props$row82, _props$row82$permissi;
              return _vm.onChangeSwitch(isChecked, _vm.mapPermissionsIds((_props$row82 = props.row) === null || _props$row82 === void 0 ? void 0 : (_props$row82$permissi = _props$row82.permissions) === null || _props$row82$permissi === void 0 ? void 0 : _props$row82$permissi.data), true);
            }
          }
        })], 1) : props.column.field === 'access' ? _c('div', [(_props$row83 = props.row) !== null && _props$row83 !== void 0 && _props$row83.permissions ? [_vm._l((_props$row84 = props.row) === null || _props$row84 === void 0 ? void 0 : (_props$row84$permissi = _props$row84.permissions) === null || _props$row84$permissi === void 0 ? void 0 : _props$row84$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'access' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'create' ? _c('div', [(_props$row85 = props.row) !== null && _props$row85 !== void 0 && _props$row85.permissions ? [_vm._l((_props$row86 = props.row) === null || _props$row86 === void 0 ? void 0 : (_props$row86$permissi = _props$row86.permissions) === null || _props$row86$permissi === void 0 ? void 0 : _props$row86$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'create' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'show' ? _c('div', [(_props$row87 = props.row) !== null && _props$row87 !== void 0 && _props$row87.permissions ? [_vm._l((_props$row88 = props.row) === null || _props$row88 === void 0 ? void 0 : (_props$row88$permissi = _props$row88.permissions) === null || _props$row88$permissi === void 0 ? void 0 : _props$row88$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'show' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'edit' ? _c('div', [(_props$row89 = props.row) !== null && _props$row89 !== void 0 && _props$row89.permissions ? [_vm._l((_props$row90 = props.row) === null || _props$row90 === void 0 ? void 0 : (_props$row90$permissi = _props$row90.permissions) === null || _props$row90$permissi === void 0 ? void 0 : _props$row90$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'edit' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'delete' ? _c('div', [(_props$row91 = props.row) !== null && _props$row91 !== void 0 && _props$row91.permissions ? [_vm._l((_props$row92 = props.row) === null || _props$row92 === void 0 ? void 0 : (_props$row92$permissi = _props$row92.permissions) === null || _props$row92$permissi === void 0 ? void 0 : _props$row92$permissi.data, function (item) {
          return [(item === null || item === void 0 ? void 0 : item.group) == 'delete' ? [_c('b-form-checkbox', {
            key: item === null || item === void 0 ? void 0 : item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item === null || item === void 0 ? void 0 : item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          })] : _vm._e()];
        })] : _vm._e()], 2) : props.column.field === 'others' ? _c('div', [(_props$row93 = props.row) !== null && _props$row93 !== void 0 && _props$row93.permissions ? _vm._l((_props$row94 = props.row) === null || _props$row94 === void 0 ? void 0 : (_props$row94$permissi = _props$row94.permissions) === null || _props$row94$permissi === void 0 ? void 0 : _props$row94$permissi.data, function (item, index) {
          var _props$row95, _props$row95$permissi, _props$row96, _props$row96$permissi;
          return _c('div', {
            key: index
          }, [index % 2 === 0 ? _c('b-row', [_c('b-col', {
            attrs: {
              "cols": "6"
            }
          }, [item.group === 'others' ? [_c('b-form-checkbox', {
            key: item.id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(item.id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, item.id);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("strSnakeToPascal")(item.name)) + " ")])] : _vm._e()], 2), (_props$row95 = props.row) !== null && _props$row95 !== void 0 && (_props$row95$permissi = _props$row95.permissions) !== null && _props$row95$permissi !== void 0 && _props$row95$permissi.data[index + 1] ? _c('b-col', {
            attrs: {
              "cols": "6"
            }
          }, [((_props$row96 = props.row) === null || _props$row96 === void 0 ? void 0 : (_props$row96$permissi = _props$row96.permissions) === null || _props$row96$permissi === void 0 ? void 0 : _props$row96$permissi.data[index + 1].group) === 'others' ? [_c('b-form-checkbox', {
            key: props.row.permissions.data[index + 1].id,
            attrs: {
              "checked": _vm.roleHasPermissions.includes(props.row.permissions.data[index + 1].id),
              "name": "check-button",
              "switch": "",
              "inline": ""
            },
            on: {
              "change": function change(isChecked) {
                return _vm.onChangeSwitch(isChecked, props.row.permissions.data[index + 1].id);
              }
            }
          }, [_vm._v(" " + _vm._s(_vm._f("strSnakeToPascal")(props.row.permissions.data[index + 1].name)) + " ")])] : _vm._e()], 2) : _vm._e()], 1) : _vm._e()], 1);
        }) : _vm._e()], 2) : _vm._e()];
      }
    }])
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }